import { useEffect, useState } from 'react';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { IOption } from 'interfaces';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import { supplierService } from 'services/api';
import { DatePickerAdapter } from 'components/form/DatePickerAdapter';
import { required } from 'helpers/validators';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';

interface InvoiceHeaderFormParams {
  onSubmit: any;
}
function InvoiceHaderForm(params: InvoiceHeaderFormParams) {
  const { t } = useTranslation();
  const { onSubmit } = params;

  const [suppliers, setSuppliers] = useState<IOption[]>([]);

  useEffect(() => {
    supplierService.getAllBaseInformation().then((res) => {
      setSuppliers(
        res.map((supplier) => {
          return {
            ...supplier,
            code: `${supplier.code} - ${supplier.company_name}`
          };
        })
      );
    });
  }, []);

  return (
    <div>
      <ReactFinalForm onSubmit={onSubmit} formId="newInvoice" hideControls>
        <div className="flex flex-wrap">
          <div className="w-full p-2">
            <IdentityField
              name="supplier"
              component={AutocompleteAdapter}
              options={suppliers}
              placeholder={t('global.contract')}
              label={t('global.contract')}
              validate={required}
              required
            />
          </div>
          <div className="p-2 w-full md:w-1/2">
            <IdentityField
              name="ref"
              label={t(`entities.ddt.invoice_ref`)}
              component={TextFieldAdapter}
              required
            />
          </div>
          <div className="p-2 w-full md:w-1/2">
            <IdentityField name="date" label={t(`global.date`)} component={DatePickerAdapter} />
          </div>
          <div className="w-full p-2">
            <IdentityField
              name="notes"
              component={TextFieldAdapter}
              placeholder={t('global.notes')}
              label={t('global.notes')}
            />
          </div>
        </div>
      </ReactFinalForm>
    </div>
  );
}

export default InvoiceHaderForm;
